import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * ElectricalHeatingStatus Partial Translation Cell
 * Translates electricalHeatingStatus enum into understandable values
 */
export const electricalHeatingStatusPartial: Columns<any> = {
  title: 'enum.meteringpoint.electricalheatingstatus.title',
  key: 'electricalHeatingStatus',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'enum.meteringpoint.electricalheatingstatus.notspecified',
    d14Missing: 'enum.meteringpoint.electricalheatingstatus.d14missing',
    d14awaitingcreation: 'enum.meteringpoint.electricalheatingstatus.d14awaitingcreation',
    d14creationfailed: 'enum.meteringpoint.electricalheatingstatus.d14creationfailed',
    d14mustberemoved: 'enum.meteringpoint.electricalheatingstatus.d14mustberemoved',
    d14awaitingremoval: 'enum.meteringpoint.electricalheatingstatus.d14awaitingremoval',
    d14removalfailed: 'enum.meteringpoint.electricalheatingstatus.d14removalfailed'
  }
}
